import {
  getWarholOutputSettingsResponseSchema,
  type UpdateWarholOutputSettingsBody,
  updateWarholOutputSettingsResponseSchema,
} from "@mg/schemas/src/christo/catalyst";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";
import { parseResponse } from "../utils/parseResponse";

export async function getWarholOutputSettings() {
  const json = await smartFetch(`${API_URL}/private/catalyst/output-guidance`, {
    method: "GET",
  });
  return parseResponse(getWarholOutputSettingsResponseSchema, json);
}

export async function updateWarholOutputSettings(
  payload: UpdateWarholOutputSettingsBody,
) {
  const json = await smartFetch(`${API_URL}/private/catalyst/output-guidance`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return updateWarholOutputSettingsResponseSchema.parse(json);
}
